import { useEffect, useMemo, useState } from "react";
import http from "services/httpService";

function useFetchGrade(userplanId) {
  const [loading, setLoading] = useState(true);
  const [userplanDataSelected, setUserplanDataSelected] = useState();
  const [selectables, setSelectables] = useState();
  const [gradesDetail, setGradesDetail] = useState([]);

  const isFlat = useMemo(() => {
    return gradesDetail.length === 1;
  }, [gradesDetail]);

  const grades = useMemo(() => {
    const response = [
      {
        sum_insured: {
          data: {
            values: [100000, 200000, 500000]
          }
        },
        dependents: {
          covered: ["Self", "Spouse", "Son"],
          children: {
            count: 2,
            age_limit: [10, 15],
          },
          parental: {
            age_limit: [10, 35],
          },
        },
        attributes: [
          {
            name: "Maternity Coverage",
            display_name: "Maternity Coverage",
            description: "Maternity coverage for the spouse",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "METRO_NON_METRO", // METRO_NON_METRO | LIST
              values: {
                metro: {
                  delivery: {
                    normal: 50000,
                    // limit: 50000,
                    // min: 5000, // optional
                    // max: 100000, // optional
                    cesarian: 100000, // null in the case of min_max
                    remarks: "Some Remarks",
                  },
                  new_born: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                  natal: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                },
                non_metro: {
                  delivery: {
                    // limit: 50000,
                    normal: 50000,
                    // min: 5000, // optional
                    // max: 100000, // optional
                    cesarian: 100000,
                    remarks: "Some Remarks",
                  },
                  new_born: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                  natal: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                },
              },
            },
          },
          {
            name: "Room Rent Limit",
            display_name: "Room Rent",
            description: "Room rent desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "METRO_NON_METRO", // METRO_NON_METRO | LIST
              values: {
                metro: {
                  normal: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  icu: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  remarks: "Some Remarks",
                },
                non_metro: {
                  normal: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  icu: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  remarks: "Some Remarks",
                },
              },
            },
          },
          {
            name: "Disease Wise Sub limit",
            display_name: "Disease Wise Sublimit",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "LIST",
              values: [
                {
                  disease: "Cancer",
                  limit: 100000,
                  remarks: null,
                },
                {
                  disease: "Heart",
                  limit: 200000,
                  remarks: "Some Remarks",
                },
              ],
            },
          },
          {
            name: "Ambulance Charges", // THIS FORMAT WILL BE USED FOR ALL ATTRIBUTES except"Room Rent Limit" maternity, disease_wise and co_payment
            display_name: "Ambulance Charges",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "DEFAULT",
              values: {
                limit: 5000,
                min: 500, // only in the case of rate sheet
                max: 10000, // only in the case of rate sheet
                remarks: "Some Remarks",
              },
            },
          },
          {
            name: "Co Payment",
            display_name: "Co Payment",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "DEFAULT",
              values: {
                esc: {
                  limit: 5000,
                  min: 500, // only in the case of rate sheet
                  max: 10000, // only in the case of rate sheet
                },
                parents: {
                  limit: 5000,
                  min: 500, // only in the case of rate sheet
                  max: 10000, // only in the case of rate sheet
                },
              },
            },
          },
        ],
        coverage_notes: ["Some Note", "Other Note"],
        exclusions: ["Some Exclusion", "Some other Exclusion"],
      },
      {
        sum_insured: {
          data: {
            values: [100000]
          }
        },
        dependents: {
          covered: ["Self", "Spouse", "Son"],
          children: {
            count: 2,
            age_limit: [10, 15],
          },
          parental: {
            age_limit: [10, 15],
          },
        },
        attributes: [
          {
            name: "Maternity Coverage",
            display_name: "Maternity Coverage",
            description: "Maternity coverage for the spouse",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "METRO_NON_METRO", // METRO_NON_METRO | LIST
              values: {
                metro: {
                  delivery: {
                    // limit: 50000,
                    normal: 50000,
                    // min: 5000, // optional
                    // max: 100000, // optional
                    cesarian: 100000, // null in the case of min_max
                    remarks: "Some Remarks",
                  },
                  new_born: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                  natal: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                },
                non_metro: {
                  delivery: {
                    normal: 50000,
                    cesarian: 100000,
                    remarks: "Some Remarks",
                  },
                  new_born: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                  natal: {
                    limit: 50000,
                    remarks: "Some Remarks",
                  },
                },
              },
            },
          },
          {
            name: "Room Rent Limit",
            display_name: "Room Rent",
            description: "Room rent desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "METRO_NON_METRO", // METRO_NON_METRO | LIST
              values: {
                metro: {
                  normal: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  icu: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  remarks: "Some Remarks",
                },
                non_metro: {
                  normal: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  icu: {
                    percentage: 0.5,
                    max: 5000,
                  },
                  remarks: "Some Remarks",
                },
              },
            },
          },
          {
            name: "Disease Wise Sub limit",
            display_name: "Disease Wise Sublimit",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "LIST",
              values: [
                {
                  disease: "Cancer",
                  limit: 100000,
                  remarks: null,
                },
                {
                  disease: "Heart",
                  limit: 200000,
                  remarks: "Some Remarks",
                },
              ],
            },
          },
          {
            name: "Ambulance Charges", // THIS FORMAT WILL BE USED FOR ALL ATTRIBUTES except"Room Rent Limit" maternity, disease_wise and co_payment
            display_name: "Ambulance Charges",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "DEFAULT",
              values: {
                limit: 5000,
                min: 500, // only in the case of rate sheet
                max: 10000, // only in the case of rate sheet
                remarks: "Some Remarks",
              },
            },
          },
          {
            name: "Co Payment",
            display_name: "Co Payment",
            description: "Desc",
            icon: "https://neo-public-static-assets.s3.ap-south-1.amazonaws.com/assets/attributes/attr_maternity.svg",
            data: {
              type: "DEFAULT",
              values: {
                esc: {
                  limit: 5000,
                  min: 500, // only in the case of rate sheet
                  max: 10000, // only in the case of rate sheet
                },
                parents: {
                  limit: 5000,
                  min: 500, // only in the case of rate sheet
                  max: 10000, // only in the case of rate sheet
                },
              },
            },
          },
        ],
        coverage_notes: ["Some Note"],
        exclusions: ["Some Exclusion", "Some other Exclusion"],
      },
    ];
    return response;

    // return userplanDataSelected?.userplan_grades_data;
  }, [userplanDataSelected]);

  const fetchUserplanSelectedData = async () => {
    try {
      const { data } = await http.get("business/userplans_data_selected/");
      setUserplanDataSelected(data?.userplans_data[userplanId]);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchSelectables = async () => {
    const { data } = await http.get("/business/get_grade_setup_selectables/", {
      params: {
        userplan_id: userplanId,
      },
    });
    setSelectables(data);
  };

  const selectableProductNames = useMemo(() => {
    if (!selectables) return;
    const product_id_name = selectables.map((value, index) => {
      const id = value?.attribute_product_mapping_id;
      const name =
        value?.attribute_data?.attribute_ui_showables &&
        Object.keys(value?.attribute_data?.attribute_ui_showables)[0].trim();
      return [id, name];
    });
    return product_id_name;
  }, [selectables]);

  const getAttributeDetail = (attributeName, grade) => {
    const attribute = selectableProductNames.find(
      (item) => item[1] === attributeName
    );
    const attributeDetail = grade?.grade_attributes_data.find(
      (attr) => attr?.attribute_product_mapping == attribute[0]
    );
    return attributeDetail;
  };

  const setupTokenKey = () => {
    // As Plan Setup does not have "tokenKey"
    const tokenKeyExists = localStorage.getItem("tokenKey")
    if (!tokenKeyExists) {
      const getAuthToken = localStorage.getItem("auth_token");
      localStorage.setItem("tokenKey", getAuthToken)
    }
  }

  const fetchGrades = async () => {
    try {
      setupTokenKey()
      const { data } = await http.get("/business/get_plan_grade_summary/", {
        params: {
          userplan_id: userplanId,
        },
      });
      setGradesDetail(data);
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    (async function () {
      setLoading(true);
      await fetchGrades();
      // await Promise.all([fetchUserplanSelectedData(), fetchSelectables()]);
      setLoading(false);
    })();
  }, []);

  return {
    loading,
    userplanDataSelected,
    selectables,
    isFlat,
    grades: gradesDetail,
    // grades: grades,
    selectableProductNames,
    getAttributeDetail,
  };
}

export default useFetchGrade;
